import { render, staticRenderFns } from "./generales.vue?vue&type=template&id=1c63019f&scoped=true"
import script from "./generales.vue?vue&type=script&lang=js"
export * from "./generales.vue?vue&type=script&lang=js"
import style0 from "./generales.vue?vue&type=style&index=0&id=1c63019f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63019f",
  null
  
)

export default component.exports